import { normalizeMemory } from './characterMemory';
import type { CharacterOperationInput } from './operationRules';
import { evaluateOperationRules } from './operationRules';
import type { CharacterOperation } from './operationTypes';

function clampTodayIndex(index: unknown): number {
  const value = typeof index === 'number' ? index : Number(index);
  if (!Number.isFinite(value)) return 1;
  return Math.max(1, Math.min(7, Math.floor(value)));
}

/**
 * Character Operation Brain — 判断角色今天如何生活
 */
export function buildCharacterOperation(input: CharacterOperationInput): CharacterOperation {
  const memory = normalizeMemory({
    ...input.memory,
    characterId: input.memory.characterId,
    today_index: clampTodayIndex(input.today_index ?? input.memory.today_index),
  });

  const operation = evaluateOperationRules(memory);

  if (!operation.today_reason.length) {
    return {
      ...operation,
      today_reason: ['使用基础角色营运节奏。'],
    };
  }

  return operation;
}
